import useSWR from 'swr';
import useToast from '../../hooks/useToast';
import { StoreProduct } from '../../models/StoreProduct';
import { fetcher } from './swr';
import api from '../api';

// Omit<StoreProduct, 'id'>;

export type CreateStoreProductDto = Omit<
  StoreProduct,
  'id' | 'createdAt' | 'updatedAt' | 'productSKU'
> & {
  schoolId: string;
};

export default function useStoreProducts(schoolId: string) {
  const { addToast } = useToast();
  const { data, error } = useSWR<StoreProduct[]>(
    `/stores/products/${schoolId}`,
    fetcher,
    {
      dedupingInterval: 60 * 1000 * 60 * 12,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  const createStoreProduct = async (product: CreateStoreProductDto) => {
    try {
      const { data } = await api.post<StoreProduct>(
        `/stores/products`,
        product,
      );
      addToast({
        type: 'success',
        title: 'Produto adicionado com sucesso',
        description: `Produto ${data.name} adicionado com sucesso!`,
      });
    } catch (error) {
      console.error('Error creating store product:', error);
      addToast({
        type: 'error',
        title: 'Erro ao adicionar produto',
        description: 'Ocorreu um erro ao tentar adicionar o produto.',
      });
    }
  };

  return {
    data: data || [],
    error,
    createStoreProduct,
    isLoading: !error && !data,
  };
}
